(function () {
  function mount(section) {
    if (section.dataset.countdownMounted) return;
    var content = section.querySelector('[data-neko-countdown]');
    if (!content) return;
    section.dataset.countdownMounted = 'true';
    var root = document.documentElement;
    var header = document.querySelector('.neko-header-section');
    var backButton = document.getElementById('nekoBackBtn');
    var frame;

    function measure() {
      frame = null;
      var headerHeight = header ? header.getBoundingClientRect().height : 0;
      var timerHeight = content.getBoundingClientRect().height;
      root.style.setProperty('--neko-header-height', headerHeight + 'px');
      root.style.setProperty('--neko-countdown-height', timerHeight + 'px');
      if (backButton) backButton.style.top = (headerHeight + timerHeight + 12) + 'px';
    }

    function schedule() {
      if (!frame) frame = requestAnimationFrame(measure);
    }

    var resize = new ResizeObserver(schedule);
    resize.observe(content);
    if (header) resize.observe(header);
    var mutations = new MutationObserver(schedule);
    mutations.observe(content, { childList: true, subtree: true, attributes: true, attributeFilter: ['style', 'class', 'hidden'] });
    window.addEventListener('resize', schedule);
    window.addEventListener('load', schedule);
    measure();

    function unload(event) {
      if (event.target !== section) return;
      resize.disconnect();
      mutations.disconnect();
      window.removeEventListener('resize', schedule);
      window.removeEventListener('load', schedule);
      document.removeEventListener('shopify:section:unload', unload);
      if (frame) cancelAnimationFrame(frame);
      root.style.setProperty('--neko-countdown-height', '0px');
      if (backButton) backButton.style.top = ((header ? header.offsetHeight : 0) + 12) + 'px';
    }

    document.addEventListener('shopify:section:unload', unload);
  }

  document.querySelectorAll('.neko-countdown-section').forEach(mount);
  document.addEventListener('shopify:section:load', function (event) {
    if (event.target.matches('.neko-countdown-section')) mount(event.target);
  });
})();
